// src/categories/addiction.js
const KEY = "addiction";
const TITLE = "Addiction / Urge Sensations";
const SUBTITLE = "A Recovery Sensation";


const SENSATIONS = [
  "URGE TO WATCH",
  "URGE TO TOUCH",
  "CRAVING FOR ALCOHOL",
  "NEED TO CHECK PHONE",
  "RACING IMAGERY",
  "TENSION IN HANDS",
  "MENTAL OBSESSION",
  "SHAME FLASH",
  "PHYSICAL RESTLESSNESS",
  "ANTICIPATORY PLEASURE",
];

const DISH_NAMES = {
  "URGE TO WATCH": "Watch Urge",
  "URGE TO TOUCH": "Touch Urge",
  "CRAVING FOR ALCOHOL": "Alcohol Crave",
  "NEED TO CHECK PHONE": "Phone Pull",
  "RACING IMAGERY": "Racing Image",
  "TENSION IN HANDS": "Hand Tension",
  "MENTAL OBSESSION": "Obsession",
  "SHAME FLASH": "Shame Flash",
  "PHYSICAL RESTLESSNESS": "Restless Body",
  "ANTICIPATORY PLEASURE": "Anticipation",
};

const ENCOURAGEMENTS = {
  "URGE TO WATCH": "Urge is a cue — label it, breathe, and delay 5–10 minutes; urges fade.",
  "URGE TO TOUCH": "Physical habit loop — substitute a grounding movement instead.",
  "CRAVING FOR ALCOHOL": "Cue-triggered craving; delay, hydrate, and practice urge-surfing.",
  "NEED TO CHECK PHONE": "Novelty craving — set a single small delay, it reduces compulsion.",
  "RACING IMAGERY": "Mind replaying reward scenes — note them without acting.",
  "TENSION IN HANDS": "Automatic motor preparation — clench then release to reset.",
  "MENTAL OBSESSION": "Focus loop — redirect attention to a short task for 5–10 minutes.",
  "SHAME FLASH": "Emotional trigger — practice self-compassion statements.",
  "PHYSICAL RESTLESSNESS": "Dopamine surge calling for movement — short walk helps.",
  "ANTICIPATORY PLEASURE": "Reward system firing — observe and wait; the feeling will change.",
};

export default { KEY, TITLE, SUBTITLE, SENSATIONS, DISH_NAMES, ENCOURAGEMENTS };
